import { PufferfishException } from './pufferfish-exception'

export class Error404 extends PufferfishException {
    public name = 'Error404'

    public constructor(message?: string) {
        super(message, Error404)
    }
}
